<script lang="ts">
    import type {Writable} from 'svelte/store';
    import type {HeadlessTabsApiData, TabsetId} from 'shared/ui-widgets/tabset/types';
    import {getContext, onDestroy, tick} from 'svelte';
    import {exists} from 'shared/utils/custom-utils';
    import {TABS_CONTEXT_NAME} from 'shared/ui-widgets/tabset/types';

    export let tabToSelect: TabsetId | null = null;

    let lastTabCount = 0;
    let alreadySelected = false;

    const tabsApi: Writable<any> = getContext(TABS_CONTEXT_NAME);
    if (!tabsApi) {
        throw new Error(
            '<KpTabButtonsActiveTabSelector /> is missing a parent <TabGroup /> component.'
        );
    }

    let apiData: HeadlessTabsApiData;
    const apiDataUnsubscribe = tabsApi.subscribe((currentApiData: HeadlessTabsApiData) => apiData = currentApiData);
    $: if (tabToSelect || apiData.tabs.length > lastTabCount) findAndSelectTab(apiData, tabToSelect);

    function findAndSelectTab(api: HeadlessTabsApiData, tab: TabsetId): boolean {
        const tabElement = api.tabs.find((element) => element.dataset.tab === tab);
        lastTabCount = api.tabs.length;

        if (!exists(tabElement) || api.tabs.length === 0 || alreadySelected) {
            return false;
        }

        const tabIndex = api.tabs.indexOf(tabElement);
        if (tabIndex === -1) {
            return false;
        }

        tick().then(() => {
            alreadySelected = true;
            api.setSelectedIndex(tabIndex);
        });

        return true;
    }

    onDestroy(() => {
        apiDataUnsubscribe();
    });
</script>
